import { render, staticRenderFns } from "./AccessibilityEcomotive.vue?vue&type=template&id=b5b3d02a&scoped=true"
var script = {}
import style0 from "./AccessibilityEcomotive.vue?vue&type=style&index=0&id=b5b3d02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b3d02a",
  null
  
)

export default component.exports